module.exports = __webpack_public_path__ + "static/media/mr.0c68579e.png";